/**
 * Created by noOne on 03/01/2018.
 */
"use strict";

import Present from "./Present";

export default class Simon {
    constructor(container3D) {

        this._container3D = container3D;

        /**
         * @type {number}
         * @private
         */
        this._numPresents = 1;

        //  this._view = P3.createSprite("")

        const a = Common.assets;
        const textureArray = [a.texture("simon_1"), a.texture("simon_2"), a.texture("simon_3")];
        this._view = new PIXI.extras.AnimatedSprite(textureArray);
        this._view.animationSpeed = 0.2;
        this._view.loop = false;
        this._view.anchor = new PIXI.Point(0.5, 0.5);
        this._view.visible = false;
        this._view.x = (Common.STAGE_WIDTH + P3.View.width) * 0.5 - 125;//rhs
        this._view.y = P3.View.height * 0.5;
        this._view.rotation = -Math.PI * 0.2;
    }

    popout(getPresCB) {

        this._view.gotoAndStop(0);
        const start = new PIXI.Point(this._view.x, this._view.y);

        delay(()=> {
            this._view.visible = true;

            TweenMax.from(this.view, 0.5, {
                x: this._view.x + 300,
                y: this._view.y + 300,
                ease: Power2.easeOut,
                yoyoEase: Power2.easeIn,
                onComplete: ()=> {
                    this._view.position = start;
                    this._view.visible = false;
                },
                repeat: 1,
                repeatDelay: 0.65,
                yoyo: true
            });

            delay(()=> {
                this._view.play();
                delay(()=> {
                    let present = this.dropPresent();
                    if (getPresCB) getPresCB(present);
                }, 0.05, this);
            }, 0.5, this);

        }, 0.5, this);

    }

    dropPresent() {

        const present = new Present(null, this._container3D);

        present.visible = false;

        present.view = P3.createSprite("santa_heart", present);
        present.x = P3.View.width;
        present.y = 0;
        present.view.anchor.set(0.5, 0);
        present.view.width = 150;
        present.view.height = 150;

        delay(()=> {
            Common.audio.playSound("sfx_heart_throw_00");
            present.visible = true;
        }, 0.2, this);

        const t = 0.75;
        TweenMax.to(present.view, t * 0.5, {
            yoyo: true,
            repeat: 1,
            ease: Power1.easeOut,
            yoyoEase: Power1.easeIn,
            y: -675,
            onComplete: ()=> {
                present.reveal();
            }
        });

        TweenMax.to(present, t, {x: P3.View.width * 0.5, y: -P3.View.height * 1.5, ease: Power0.easeNone});

        return present;

    }

    get view() {
        return this._view;
    }
}